import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
// import { uuid } from "@ant-design/plots/es/utils";
import { Checkbox, Form, Input, Spin } from "antd";
import parsePhoneNumber from "libphonenumber-js";
import { doGetWorkspacePage } from "stores/slices/workspace";

import BulkSMSCreditBalance from "components/bulkSMSCreditBalance";
import SelectMultiple from "components/inputs/selectSearchSingle";

import AppButton from "../../../components/button";
import AppSelect from "../../../components/inputs/select";
import {
  ADDRESS_STATUS,
  CHANNEL_NAME,
  CHANNEL_PROVIDER,
  CHANNEL_STATUS,
  PATTERNS,
  SUPPLIERS,
  USER_TYPE,
} from "../../../constants/appConstant";
import { doGetAllChannel } from "../../../stores/slices/channel";
import {
  doCreateAddress,
  doGetAddressDetail,
  doUpdateAddress,
  setServiceNumber,
  // setServiceId,
} from "../../../stores/slices/numbers";

import NumberSettingTab from "./numberSettingTab";

import styles from "../../../components/styles.module.scss";
const NumberForm = props => {
  const {
    isViewForm,
    numberSelected,
    onCancel,
    userType,
    setLoadingList,
    loadingList,
    onSuccess,
    onUpdate,
    statusOptions,
  } = props;
  const formRef = useRef(null);
  const voiceSettingFormRef = useRef(null);
  const voiceSettingRef = useRef(null);
  const mmsSettingRef = useRef(null);
  const [form] = Form.useForm();

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isView, setIsView] = useState(true);
  const [dataLoading, setDataLoading] = useState(true);
  const [channelLoading, setChannelLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [channelList, setChannelList] = useState(null);
  const [isShowWorkspaceField, setIsShowWorkspaceField] = useState(false);
  const [workspaceSelectedId, setWorkspaceSelectedId] = useState(null);
  const [serviceDetail, setServiceDetail] = useState(null);
  const [channelSelected, setChannelSelected] = useState(null);

  const [listAllWorkspace, setListAllWorkspace] = useState([]);
  const [totalWorkspacePages, setTotalWorkspacePages] = useState(0);
  const [protocolListSelected, setProtocolListSelected] = useState([]);
  const [workspacecQueries, setWorkspaceQueries] = useState({
    pageNumber: 1,
    pageSize: 10,
    statuses: ["ACTIVE"],
  });
  const [workspaceOption, setOptionWorkspace] = useState([]);

  const handleChangeProtocolList = protocols => {
    setProtocolListSelected([...protocols]);
  };

  const providerOptions = [
    {
      label: t("channelProvider.sms"),
      value: CHANNEL_PROVIDER.SMS,
    },
    {
      label: t("channelProvider.mms"),
      value: CHANNEL_PROVIDER.MMS,
    },
    {
      label: t("channelProvider.whatsapp"),
      value: CHANNEL_PROVIDER.WhatsApp,
    },
    {
      label: t("channelProvider.voice"),
      value: CHANNEL_PROVIDER.Voice,
    },
  ];

  useEffect(() => {
    if (userType === USER_TYPE.SUPER_ADMIN) {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
  }, []);

  const fetchListWorkspace = async request => {
    const newRequest = {
      ...request,
      pageNumber: request.pageNumber,
      pageSize: request.pageSize,
      statuses: ["ACTIVE"],
      sortFieldWorkspace: "createdTime",
    };
    if (
      totalWorkspacePages > 0 &&
      totalWorkspacePages < newRequest.pageNumber
    ) {
      return;
    }
    if (request.isReset) {
      setOptionWorkspace([]);
      setListAllWorkspace([]);
      delete newRequest.isReset;
    }
    setLoadingList(true);
    const { payload } = await dispatch(doGetWorkspacePage(newRequest));
    if (payload && typeof payload !== "string") {
      if (request.isReset) {
        setListAllWorkspace(removeDuplicates([...payload.content]));
      } else {
        setListAllWorkspace(
          removeDuplicates([...listAllWorkspace, ...payload.content])
        );
      }
      setTotalWorkspacePages(payload.totalPages);
      setWorkspaceQueries(newRequest);
    }
    setLoadingList(false);
  };
  const removeDuplicates = arr => {
    return arr.filter(
      (ele, ind) => ind === arr.findIndex(elem => elem.id === ele.id)
    );
  };

  useEffect(() => {
    if (listAllWorkspace && listAllWorkspace?.length > 0) {
      const newOptions = listAllWorkspace.map(item => {
        return {
          key: item.id,
          label: item.name,
        };
      });
      setOptionWorkspace(newOptions);
    } else {
      setOptionWorkspace([]);
    }
  }, [listAllWorkspace]);

  const handleScrollWorkspace = event => {
    const clientHeight = event.target.clientHeight;
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    if (
      clientHeight + 10 - (scrollHeight - scrollTop) > 0 &&
      workspacecQueries.pageNumber <= totalWorkspacePages &&
      !loadingList
    ) {
      fetchListWorkspace({
        ...workspacecQueries,
        pageNumber: workspacecQueries.pageNumber + 1,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
  };

  const handleSearchKeyWorkspace = key => {
    if (key) {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        searchKeyName: key,
        isReset: true,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    } else {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        isReset: true,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
  };

  const validateMessages = {
    required: t("validate.required"),
  };

  const onFinish = async fieldsValue => {
    if (voiceSettingFormRef.current) {
      const { formErrors, formTouch } = voiceSettingFormRef.current;

      if (formErrors?.forwardNumber && formTouch?.forwardNumber) {
        return;
      }
    }

    let params = {
      address: fieldsValue["number"],
      supplier: fieldsValue["supplier"],
      serviceStatus: fieldsValue["status"],
      channelId: fieldsValue["channel"],
      sms: fieldsValue["protocols"]?.includes(CHANNEL_PROVIDER.SMS)
        ? true
        : false,
      mms: fieldsValue["protocols"]?.includes(CHANNEL_PROVIDER.MMS)
        ? true
        : false,
      whatsapp: fieldsValue["protocols"]?.includes(CHANNEL_PROVIDER.WhatsApp)
        ? true
        : false,
      voice: fieldsValue["protocols"]?.includes(CHANNEL_PROVIDER.Voice)
        ? true
        : false,
    };

    if (userType === USER_TYPE.SUPER_ADMIN && fieldsValue["workspace"]) {
      params.workspaceId = fieldsValue["workspace"];
    }

    if (mmsSettingRef?.current?.mmsSettingValues) {
      params = {
        ...params,
        sendReceiveMms: mmsSettingRef.current.mmsSettingValues?.sendMMS,
      };
    }

    setLoading(true);

    if (numberSelected) {
      params.id = numberSelected.id;
      if (userType === USER_TYPE.SUPER_ADMIN) {
        params.workspaceId = fieldsValue["workspace"];
      }
      if (!params.channelId) {
        delete params.channelId;
      }
      const { payload } = await dispatch(doUpdateAddress(params));
      if (payload && payload.status === 200) {
        const serviceId = payload?.data?.id;
        voiceSettingRef?.current?.updateVoiceSetting(serviceId);
        setLoading(false);
        setIsRefresh(!isRefresh);
        onSuccess();
      } else {
        setLoading(false);
      }
    } else {
      if (!params.channelId) {
        delete params.channelId;
      }
      const { payload } = await dispatch(doCreateAddress(params));
      if (payload && payload.status === 200) {
        const serviceId = payload?.data?.id;
        voiceSettingRef?.current?.updateVoiceSetting(serviceId);
        setLoading(false);
        setIsRefresh(!isRefresh);
        onSuccess();
      } else {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (numberSelected && numberSelected.id) {
      getServiceDetail().then(res => {
        if (res.id) {
          setServiceDetail(res);
        }
      });
      if (userType === USER_TYPE.USER) {
        getListChannelByWorkspace().then(res => {
          const list = res
            .filter(item => item.status === CHANNEL_STATUS.ENABLED)
            .sort((a, b) => {
              return a.name.toLowerCase() < b.name.toLowerCase()
                ? -1
                : a.name.toLowerCase() > b.name.toLowerCase()
                ? 1
                : 0;
            })
            .map(item => {
              return {
                ...item,
                value: item.id,
                label:
                  item.name === CHANNEL_NAME.BULKSMS
                    ? t("channelName.BULKSMS")
                    : item.name,
              };
            });
          setChannelList(list);
          setChannelLoading(false);
        });
      }
      if (userType === USER_TYPE.SUPER_ADMIN) {
        setOptionWorkspace([
          {
            key: numberSelected.workspace?.id,
            label: numberSelected.workspace?.name,
          },
        ]);
      }
    }
  }, [numberSelected]);

  useEffect(() => {
    if (workspaceSelectedId) {
      setChannelLoading(true);
      getListChannelByWorkspace().then(res => {
        const list = res
          .filter(item => item.status === CHANNEL_STATUS.ENABLED)
          .sort((a, b) => {
            return a.name.toLowerCase() < b.name.toLowerCase()
              ? -1
              : a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : 0;
          })
          .map(item => {
            return {
              ...item,
              value: item.id,
              label:
                item.name === CHANNEL_NAME.BULKSMS
                  ? t("channelName.BULKSMS")
                  : item.name,
            };
          });
        setChannelList(list);
        setChannelLoading(false);
      });
    }
  }, [workspaceSelectedId]);

  useEffect(() => {
    initialValue(serviceDetail);
  }, [serviceDetail, isViewForm]);

  const getListChannelByWorkspace = async () => {
    const { payload } = await dispatch(
      doGetAllChannel({ workspaceId: workspaceSelectedId })
    );
    return payload?.data;
  };

  const getServiceDetail = async () => {
    const { payload } = await dispatch(doGetAddressDetail(numberSelected.id));
    return payload?.data || null;
  };

  const initialValue = itemSelected => {
    let protocolsEnable = [];

    let frmData;
    if (itemSelected) {
      Object.entries(itemSelected.configuration)?.forEach(([key, value]) => {
        if (value) {
          switch (key) {
            case CHANNEL_PROVIDER.SMS:
              protocolsEnable.push(CHANNEL_PROVIDER.SMS);
              break;
            case CHANNEL_PROVIDER.MMS:
              protocolsEnable.push(CHANNEL_PROVIDER.MMS);
              break;
            case CHANNEL_PROVIDER.WhatsApp.toLowerCase():
              protocolsEnable.push(CHANNEL_PROVIDER.WhatsApp);
              break;
            case CHANNEL_PROVIDER.Voice.toLowerCase():
              protocolsEnable.push(CHANNEL_PROVIDER.Voice);
              break;
          }
        }
      });
      frmData = {
        supplier: itemSelected.supplier,
        label: itemSelected.label,
        number: itemSelected.address,
        status: itemSelected.status,
        dateUpdated: itemSelected.updatedTime
          ? itemSelected.updatedTime
          : itemSelected.createdTime,
        workspace:
          userType === USER_TYPE.SUPER_ADMIN && itemSelected.workspace
            ? itemSelected.workspace?.id
            : null,
        channel: itemSelected.channelId,
        // channelEnable: channelEnable,
        protocols: protocolsEnable,
      };
      // Set service number
      dispatch(setServiceNumber(itemSelected.address));
      setChannelSelected(itemSelected.channel);
      setIsShowWorkspaceField(
        itemSelected.status === ADDRESS_STATUS.ASSIGNED ||
          itemSelected.status === ADDRESS_STATUS.RETURNED
      );
      setWorkspaceSelectedId(frmData.workspace);
      setProtocolListSelected(frmData?.protocols);
    } else {
      frmData = {
        supplier: SUPPLIERS.SINCH,
        status: ADDRESS_STATUS.AVAILABLE,
        protocols: protocolsEnable,
      };
    }

    form.setFieldsValue(frmData);

    setIsView(isViewForm);
    setDataLoading(false);
  };

  const checkValidPhoneNumber = phone => {
    let phoneNumber = phone;
    if (
      PATTERNS.PHONE_NUMBER_LENGTH.test(phone) &&
      PATTERNS.ZERO_ONLY.test(phone)
    ) {
      const validPhoneNumber = parsePhoneNumber(phoneNumber);
      if (validPhoneNumber && validPhoneNumber.isPossible()) {
        if (validPhoneNumber.country && validPhoneNumber.isValid()) {
          const newValue = validPhoneNumber.formatInternational();
          return newValue.replaceAll(" ", "").replaceAll("+", "");
        }
      } else {
        phoneNumber = phone.includes("+") ? phone : `+${phoneNumber}`;
        const validContactNumber = parsePhoneNumber(phoneNumber);
        if (validContactNumber && validContactNumber.isPossible()) {
          if (validContactNumber.country && validContactNumber.isValid()) {
            const newValue = validContactNumber.formatInternational();
            return newValue.replaceAll(" ", "").replaceAll("+", "");
          } else {
            return false;
          }
        } else {
          const validPhoneNumber2 = parsePhoneNumber(phone, "AU");
          if (validPhoneNumber2 && validPhoneNumber2.isPossible()) {
            if (validPhoneNumber2.country && validPhoneNumber2.isValid()) {
              const newValue = validPhoneNumber2.formatInternational();
              return newValue.replaceAll(" ", "").replaceAll("+", "");
            } else {
              return false;
            }
          } else {
            const validContactNumber2 = parsePhoneNumber(phoneNumber, "AU");
            if (validContactNumber2 && validContactNumber2.isPossible()) {
              if (
                validContactNumber2.country &&
                validContactNumber2.isValid()
              ) {
                const newValue = validContactNumber2.formatInternational();
                return newValue.replaceAll(" ", "").replaceAll("+", "");
              } else {
                return false;
              }
            }
          }
        }
      }
    } else {
      return false;
    }
  };

  return (
    <>
      {dataLoading ? (
        <div style={{ margin: "30px", width: "100%", textAlign: "center" }}>
          <Spin size="large" />
        </div>
      ) : (
        <div style={{ height: "100%" }}>
          <Form
            form={form}
            ref={formRef}
            layout={"vertical"}
            name={"nest-messages"}
            validateMessages={validateMessages}
            onFinish={onFinish}
          >
            <>
              <p className={styles.required} style={numberFormStyle.labelTitle}>
                {t("numbers.number")}
              </p>
              <Form.Item
                name="number"
                rules={[
                  { required: true, type: "string" },
                  ({ setFieldValue }) => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.resolve();
                      } else {
                        if (value.length >= 6) {
                          const isValid = checkValidPhoneNumber(value);
                          if (isValid) {
                            setFieldValue("number", isValid);
                            // Set service number
                            dispatch(setServiceNumber(isValid));
                            return Promise.resolve();
                          } else {
                            return Promise.reject(
                              new Error(`${t("validate.phoneNumber.invalid")}`)
                            );
                          }
                        } else {
                          return Promise.reject(
                            new Error(`${t("validate.min_length_6")}`)
                          );
                        }
                      }
                    },
                  }),
                ]}
              >
                <Input
                  disabled={isView || userType !== USER_TYPE.SUPER_ADMIN}
                  placeholder={t("text.userPhoneNumber")}
                  maxLength={45}
                />
              </Form.Item>
              {/* {userType === USER_TYPE.SUPER_ADMIN && ( */}
              <>
                <p style={numberFormStyle.labelTitle}>
                  {t("numbers.supplier")}
                </p>
                <Form.Item name="supplier" rules={[{ required: true }]}>
                  <AppSelect
                    disabled={isView}
                    options={[
                      {
                        value: SUPPLIERS.SINCH,
                        label: t("suppliers.SINCH"),
                      },
                      {
                        value: SUPPLIERS.TWILO,
                        label: t("suppliers.TWILO"),
                      },
                    ]}
                  />
                </Form.Item>
                <p style={numberFormStyle.labelTitle}>
                  {t("numbers.protocols")}
                </p>
                <Form.Item name="protocols">
                  <Checkbox.Group
                    options={providerOptions}
                    disabled={isViewForm}
                    onChange={handleChangeProtocolList}
                  ></Checkbox.Group>
                </Form.Item>
              </>
              {/* )} */}

              <p style={numberFormStyle.labelTitle}>{t("numbers.status")}</p>
              <Form.Item name="status" rules={[{ required: true }]}>
                <AppSelect
                  disabled={isView}
                  loading={loadingList}
                  showSearch
                  optionFilterProp="children"
                  isFilterOption={true}
                  isFilterSort={true}
                  options={statusOptions}
                  onChange={value => {
                    setIsShowWorkspaceField(
                      value === ADDRESS_STATUS.ASSIGNED ||
                        value === ADDRESS_STATUS.RETURNED
                    );
                    formRef.current.setFieldsValue({
                      status: value,
                    });
                  }}
                />
              </Form.Item>
              {isShowWorkspaceField && (
                <>
                  {userType === USER_TYPE.SUPER_ADMIN && (
                    <>
                      <p
                        className={styles.required}
                        style={numberFormStyle.labelTitle}
                      >
                        {t("messageTemplates.workspace")}
                      </p>
                      <Form.Item name="workspace" rules={[{ required: true }]}>
                        <SelectMultiple
                          type={"select-search"}
                          disabled={
                            numberSelected &&
                            (numberSelected.status ===
                              ADDRESS_STATUS.ASSIGNED ||
                              numberSelected.status === ADDRESS_STATUS.RETURNED)
                              ? true
                              : isView
                          }
                          loading={loadingList}
                          showSearch
                          allowClear={false}
                          optionFilterProp="children"
                          options={workspaceOption}
                          onChange={value => {
                            setWorkspaceSelectedId(value);
                            setChannelSelected(null);
                            formRef.current.setFieldsValue({
                              workspaceId: value,
                              channel: null,
                            });
                          }}
                          config={{
                            width: "100%",
                          }}
                          handleSearch={handleSearchKeyWorkspace}
                          handleScroll={handleScrollWorkspace}
                        />
                      </Form.Item>
                    </>
                  )}

                  {(workspaceSelectedId || userType === USER_TYPE.USER) && (
                    <>
                      <p style={numberFormStyle.labelTitle}>
                        {t("numbers.channel")}
                      </p>
                      <Form.Item
                        name="channel"
                        style={{
                          margin:
                            channelSelected && channelSelected.apiKey ? 0 : 24,
                        }}
                      >
                        <AppSelect
                          disabled={isView || channelLoading}
                          loading={channelLoading}
                          showSearch
                          optionFilterProp="children"
                          isFilterOption={true}
                          isFilterSort={true}
                          options={channelList}
                          onChange={value => {
                            const item =
                              channelList?.find(item => item.id === value) ||
                              null;
                            setChannelSelected(item);
                            formRef.current.setFieldsValue({
                              channel: value,
                            });
                            if (
                              item &&
                              (!numberSelected ||
                                (numberSelected.status !==
                                  ADDRESS_STATUS.ASSIGNED &&
                                  numberSelected.status !==
                                    ADDRESS_STATUS.RETURNED))
                            ) {
                              let channelEnable = [];
                              Object.entries(item.provider).forEach(
                                ([key, value]) => {
                                  if (value) {
                                    switch (key) {
                                      case CHANNEL_PROVIDER.SMS:
                                        channelEnable.push(
                                          CHANNEL_PROVIDER.SMS
                                        );
                                        break;
                                      case CHANNEL_PROVIDER.MMS:
                                        channelEnable.push(
                                          CHANNEL_PROVIDER.MMS
                                        );
                                        break;
                                      case CHANNEL_PROVIDER.WhatsApp.toLowerCase():
                                        channelEnable.push(
                                          CHANNEL_PROVIDER.WhatsApp
                                        );
                                        break;
                                      case CHANNEL_PROVIDER.Voice.toLowerCase():
                                        channelEnable.push(
                                          CHANNEL_PROVIDER.Voice
                                        );
                                        break;
                                    }
                                  }
                                }
                              );
                              formRef.current.setFieldsValue({
                                channelEnable: channelEnable,
                              });
                            }
                          }}
                        />
                      </Form.Item>
                      {channelSelected && channelSelected.apiKey && (
                        <div>
                          <BulkSMSCreditBalance
                            apiKey={channelSelected.apiKey}
                          />
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
            </>
          </Form>
          {protocolListSelected?.length > 0 && (
            <NumberSettingTab
              voiceSettingRef={voiceSettingRef}
              voiceSettingFormRef={voiceSettingFormRef}
              mmsSettingRef={mmsSettingRef}
              isViewForm={isViewForm}
              numberSelected={numberSelected}
              protocolListSelected={protocolListSelected}
            />
          )}
          <div
            style={{
              marginTop: "28px",
              display: "flex",
              justifyContent: "end",
              gap: "16px",
            }}
          >
            <AppButton
              label={t("button.cancel")}
              color={"grey"}
              htmlType="button"
              loading={loading}
              onClick={() => {
                onCancel();
              }}
            />
            {isView && (
              <AppButton
                label={t("button.edit")}
                color={"blue"}
                loading={loading}
                type="primary"
                htmlType="button"
                onClick={() => {
                  onUpdate();
                }}
              />
            )}
            {!isView && userType === USER_TYPE.SUPER_ADMIN && (
              <AppButton
                label={numberSelected ? t("button.save") : t("button.create")}
                color={"blue"}
                type="primary"
                htmlType="submit"
                loading={loading}
                onClick={() => {
                  form?.submit();
                  voiceSettingFormRef?.current?.submitForm();
                  mmsSettingRef?.current?.submitForm();
                }}
              />
            )}
            {!isView && userType === USER_TYPE.USER && (
              <AppButton
                label={numberSelected ? t("button.save") : t("button.assign")}
                color={"blue"}
                type="primary"
                htmlType="submit"
                loading={loading}
                onClick={() => {
                  form?.submit();
                  voiceSettingFormRef?.current?.submitForm();
                  mmsSettingRef?.current?.submitForm();
                }}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};
const numberFormStyle = {
  labelTitle: {
    fontWeight: "bold",
    marginBottom: "6px",
  },
  lineHeightLg: {
    lineHeight: "1.2rem",
  },
  appearBox: {
    backgroundColor: "#F9FAFB",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    marginBottom: "16px",
  },
  fontWeightBold: { fontWeight: "bold" },
};
export default NumberForm;
